import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalTransition() {
  return <section className="py-16 bg-[#143524] border-y border-[#FBBF24]/20 relative overflow-hidden" data-id="element-134">
      <div className="absolute inset-0 bg-gradient-to-r from-[#FBBF24]/5 via-transparent to-[#FBBF24]/5" data-id="element-135"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-136">
        <motion.h2 initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-2xl md:text-4xl font-black text-white leading-relaxed" data-id="element-137">
          ¿Cuántas clases más vas a improvisar porque no tuviste tiempo de
          preparar material?
        </motion.h2>
      </div>
    </section>;
}